import React from 'react';
import MapsSymbol from '../../assets/img/maps-symbol.png';

let autoComplete;

function onPlaceChanged (updateQuery, setCenterAndZoomIn = () => {}) {
  try {
    const addressObject = autoComplete.getPlace();
    const query = addressObject.formatted_address;
    updateQuery(query);
    setCenterAndZoomIn({ lat: addressObject.geometry.location.lat(), lng: addressObject.geometry.location.lng() }, 12);
  } catch (e) {
    console.log('geht nicht', e);
  }
  // setZoom();
}

const PlacesAutoComplete = props => {
  const autoCompleteRef = React.useRef(null);
  const [query, setQuery] = React.useState('');
  const [fieldProps, setFieldProps] = React.useState({
    id: 1,
    locked: false,
    focussed: false,
    error: '',
    label: props.label || 'Nach Ort suchen',
    placeholder: props.placeholder || 'Nach Ort suchen'
  });

  React.useEffect(() => {
    const { mapApi } = props;
    autoComplete = new mapApi.places.Autocomplete(
      autoCompleteRef.current,
      { types: ['(cities)'], componentRestrictions: { country: 'de' } }
    );
    const listener = autoComplete.addListener('place_changed', () => {
      onPlaceChanged(props.setValue, props.setCenterAndZoomIn);
    });
    /* return () => {
      delete autoComplete;
    }; */
    // autoComplete.setFields(['address_components', 'formatted_address']);
  }, []);

  // ${(fieldProps.focussed || fieldProps.value) ? ' focussed' : ''}

  const fieldClassName = `input-field ${props.small ? 'smaller' : ''}${props.value ? ' filled' : ''} places-auto-complete`;

  return (
    <div className={fieldClassName} style={props.style}>
      {/* <img src={require('assets')} /> */}
      <input
      /* className='search-input' */
        name={props.name}
        ref={autoCompleteRef}
        type='text'
        onChange={event => props.setValue(event.target.value)}
        placeholder={fieldProps.placeholder}
        value={props.value}
        onFocus={() => !fieldProps.locked && setFieldProps(old => ({ ...old, focussed: true }))}
        onBlur={() => !fieldProps.locked && setFieldProps(old => ({ ...old, focussed: false }))}
      />
      <label htmlFor={1} className={fieldProps.error && 'error'}>
        {fieldProps.error || fieldProps.label}
      </label>
      <img src={MapsSymbol} className='input-icon' />
    </div>
  );
};

export default PlacesAutoComplete;
